import {createAction} from '@ngrx/store';
import * as _ from 'lodash';

import {
  DeleteTCResponse,
  InvoiceStatus,
  LiteBatchTimecard,
  PaymasterBatchDetails,
  PayrollBatch, PayrollEvent,
  ReleaseInvoiceRequest, ReleaseModalResponse,
  VacationHoliday
} from '../../../../common/paymaster-batch.model';
import {FilterParams} from '../../models/query-params.model';
import {BatchNote, InjectData} from '../../../../common/batch.model';
import {VaBatchStatus} from '../../../../common/notification.model';

export const Reset = createAction(
  '[Paymaster Batch Details] Reset batch Details'
);
export const RetrieveLiteBatchTimecards = createAction(
  '[Paymaster Batch Details] Retrieve Lite Batch Timecard'
);
export const RetrieveBatchDetailsSuccessful = createAction(
  '[Paymaster Batch Details] Retrieve Lite Batch Header Details Successful',
  (header: PaymasterBatchDetails) => ({header })
);
export const RetrieveBatchDetailsTcSuccessful = createAction(
  '[Paymaster Batch Details] Retrieve Batch Details Timecards Successful',
  (timecards: LiteBatchTimecard[], timecardCount: number) => ({timecards, timecardCount})
);
export const RetrievedLiteBatchTcNotFoundResponse = createAction(
  '[Paymaster Batch Details] Retrieve Lite Batch Timecards Not Found',
);
export const TimecardSort = createAction(
  '[Paymaster Batch Details] Update Timecard Sort',
  (sort: string) => ({sort})
);
export const ResetBatchTimecards = createAction(
  '[Paymaster Batch Details] Reset Batch Timecards'
);
export const TimecardSearch = createAction(
  '[Paymaster Batch Details] Update Timecard Search',
  (searchText: string) => ({searchText})
);
export const Filters = createAction(
  '[Paymaster Batch Details] Filters',
  (filters: FilterParams[]) => ({filters})
);
export const ClearFilters = createAction(
  '[Paymaster Batch Details] Clear Filters',
  (filters: FilterParams[]) => ({filters})
);
export const BatchInject = createAction(
  '[Paymaster Batch Details] Inject',
  (printSite: string, processingSite: string, billingSite: string, isReAssignCheckCodes: boolean, payrollReceivedTime: string, overridden: boolean, overrideReason: string) =>
    ({printSite, processingSite, billingSite, isReAssignCheckCodes, payrollReceivedTime, overridden, overrideReason})
);
export const BatchTimecardSelect = createAction(
  '[Paymaster Batch Details] Batch Timecard Select',
  (isSelected: boolean, timecardId: string, liteBatchTimecards: LiteBatchTimecard[]) => ({
    timecards: _.map(liteBatchTimecards, (batchTimecard) => batchTimecard.timecardId === timecardId
      ? {...batchTimecard, isSelected}
      : {...batchTimecard})
  })
);
export const BatchTimecardSelectAll = createAction(
  '[Paymaster Batch Details] Batch Timecard Select All',
  (isSelected: boolean, liteBatchTimecards: LiteBatchTimecard[]) => ({
    timecards: _.map(liteBatchTimecards, (batchTimecard: LiteBatchTimecard) => ({
      ...batchTimecard,
      isSelected: batchTimecard.invoiceStatus === InvoiceStatus.UNRELEASED ? isSelected : batchTimecard.isSelected
    }))
  })
);
export const ApplyVacationHoliday = createAction(
  '[Paymaster Batch Details] Apply Vacation Holiday',
  (vacationHoliday: VacationHoliday) => ({vacationHoliday})
);
export const OpenEnableForIPSModal = createAction(
  '[Paymaster Batch Details] Open Enable For IPS Modal'
);
export const EnableBatchInvoicesForIPS = createAction(
  '[Paymaster Batch Details] Enable Batch Invoices for IPS',
  (batchInvoices: PayrollBatch[]) => ({batchInvoices})
);
export const CloseBatchErrorsPanel = createAction(
  '[Paymaster Batch Details] CloseBatchErrorsPanel'
);

export const OpenBatchErrorsPanel = createAction(
  '[Paymaster Batch Details] OpenBatchErrorsPanel'
);

export const UnsubmitBatch = createAction(
  '[Paymaster Batch Details] Unsubmit Batch'
);

export const CloseGtnEditReportPanel = createAction(
  '[Paymaster Batch Details] Close GTN Edit Report Panel'
);

export const OpenGtnEditReportPanel = createAction(
  '[Paymaster Batch Details] Open GTN Edit Report Panel'
);

export const ReleaseBatchInvoices = createAction(
  '[Paymaster Batch Details] Release Batch Invoices',
  (releaseInvoiceRequest: ReleaseInvoiceRequest) => ({releaseInvoiceRequest})
);

export const OpenReleaseModal = createAction(
  '[Paymaster Batch Details] Open Release Modal'
);

export const DisableInjectButton = createAction(
  '[Paymaster Batch Details] DisableInjectButton',
  (isInjectButtonDisabled: boolean) => ({isInjectButtonDisabled})
);

export const ProceedWithBatchAction = createAction(
  '[Paymaster Batch Details] ProceedWithBatchAction'
);

export const UnsubmitTC = createAction(
  '[Paymaster Batch Details] Unsubmit TC',
  (timecardIds: string[]) => ({timecardIds})
);

export const UnsubmitTCSuccessful = createAction(
  '[Paymaster Batch Details] Unsubmit TC Successful'
);

export const UnsubmitTCFailed = createAction(
  '[Paymaster Batch Details] Unsubmit TC Failed'
);

export const BatchInjectFailed = createAction(
  '[Paymaster Batch Details] Batch Inject Failed'
);

export const BatchInjectSuccessful = createAction(
  '[Paymaster Batch Details] Batch Inject Successful'
);

export const BatchInjectCompleted = createAction(
  '[Paymaster Batch Details] Batch Inject Completed',
  (batchId: string) => ({batchId})
);

export const BatchInjectSuccessfulWithArchivedBatchException = createAction(
  '[Paymaster Batch Details] Batch Inject Successful with Archived Batch Exception'
);


export const UpdatePayrollEvent = createAction(
  '[Paymaster Batch Details] Update Payroll Event',
  (batchId: string, batchNumber: string, payrollEvent: PayrollEvent) => ({batchId, batchNumber, payrollEvent})
);

export const UpdateAllSelectedPayrollEvents = createAction(
  '[Paymaster Batch Details] Update Selected Payroll Events',
  (releaseModalResponse: ReleaseModalResponse) => ({releaseModalResponse})
);

export const UpdatePayrollEventSuccessful = createAction(
  '[Paymaster Batch Details] Update Payroll Event Successful'
);

export const DeleteTC = createAction(
  '[Paymaster Batch Details] Delete TC'
);

export const DeleteTCSuccessful = createAction(
  '[Paymaster Batch Details] Delete TC Successful',
  (response: DeleteTCResponse) => ({response})
);

export const DeleteTCFailed = createAction(
  '[Paymaster Batch Details] Delete TC Failed'
);

export const OpenBatchAttachmentPanel = createAction(
  '[Paymaster Batch Detail] Open Batch Attachment Panel'
);

export const CloseBatchAttachmentPanel = createAction(
  '[Paymaster Batch Detail] Close Batch Attachment Panel'
);

export const OpenPaymasterBatchNotePanel = createAction(
  '[Paymaster Batch Detail] Open Batch Note Panel',
  () => ({panelOpenStatus: true})
);

export const ClosePaymasterBatchNotePanel = createAction(
  '[Paymaster Batch Detail] Close Batch Note Panel',
  () => ({panelOpenStatus: false})
);

export const RetrievePaymasterBatchNote = createAction(
  '[Paymaster Batch Detail] Retrieve Batch Note',
  (batchId: string) => ({batchId})
);

export const RetrievePaymasterBatchNoteSuccessful = createAction(
  '[Paymaster Batch Detail] update batch Note',
  (batchNote: BatchNote) => ({batchNote})
);

export const RetrievePaymasterBatchNoteFailed = createAction(
  '[Paymaster Batch Detail] Retrieve Batch Note failed',
  (error: Error) => ({error})
);

export const InitiateBatchInject = createAction(
  '[Paymaster Batch Details] Initiate Batch Inject'
);

export const UpdateBatchSelectionStatus = createAction(
  '[Paymaster Batch Detail] Update Batch selection status',
  (batchId: string, isSelected: boolean) => ({batchId, isSelected})
);
export const SelectAllUnReleasedBatches = createAction(
  '[Paymaster Batch Detail] Select all un released batches'
);
export const ReleaseSelectedBatchInvoices = createAction(
  '[Paymaster Batch Details] Release Selected Batch Invoices',
  (releaseInvoiceRequest: ReleaseInvoiceRequest) => ({releaseInvoiceRequest})
);
export const PayrollBatchDetails = createAction(
  '[Paymaster Batch Details] Payroll Batch Details',
  (payrollBatchDetails: PayrollBatch[]) => ({payrollBatchDetails})
);
export const loadInjectData = createAction('[Inject] Load Data');
export const loadInjectDataSuccess = createAction('[Inject] Load Data Success',
  (injectData: InjectData) => ({injectData}));
export const loadInjectDataFailure = createAction('[Inject] Load Data Failure');

export const BatchDetailsVaStatusPayload = createAction(
  '[Paymaster Batch Details] Batch Details Va Status Payload',
  (message: VaBatchStatus) => ({message})
);

export const UpdateBatchDetailsVaStatus = createAction(
  '[Paymaster Batch Details] Update Batch details Va Status',
  (openExceptions: boolean) => ({openExceptions})
);
